import React, { ChangeEvent, FC } from 'react';
import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Typography,
	Stack,
	Box,
	InputLabel,
	MenuItem,
} from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { DpOutlinedInput } from '@/components/blocks/OutlinedInput';
import { DpOutlinedSelect } from '@/components/blocks/DpOutlineSelect';
import {useForm} from '@/utils/useForm';

const OPTIONS = {
	PLAYER: 'player',
	CUSTOM: 'custom',
};

type Options = typeof OPTIONS[keyof typeof OPTIONS];

type Values = {
	option: Options;
	player: string;
	customNumber: string;
	customName: string
}

const initialValues: Values = {
	option: OPTIONS.PLAYER,
	player: '',
	customNumber: '',
	customName: '',
};

export const ProductCustomPlayer: FC = () => {
	const handleInput = (evt: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = evt.target;

		if (name === 'customNumber') {
			evt.target.value = value.replace(/[^0-9]/g, '');
		}

		if (name === 'customName') {
			evt.target.value = value.replace(/[^a-zA-Z\s]/g, '').toUpperCase();
		}
	};

	const {
		values,
		handleSelectChange,
		handleInputChange,
	} = useForm<Values>(initialValues);


	return (
		<React.Fragment>
			<Box mb={2}>
				<Stack direction="row" spacing={1} alignItems="center" justifyContent="start" mb={1}>
					<AutoAwesome/>
					<Typography
						sx={{
							fontSize: 'var(--font-size-default)',
							fontWeight: 'bold',
							color: '#2C2C2C',
						}}
					>
						{'¡Personalizado!'}
					</Typography>
				</Stack>
				<Typography
					sx={{
						fontSize: 'var(--font-size-default)',
						fontWeight: 'normal',
						color: '#2C2C2C',
						display: 'inline',
					}}
				>
					{'Personaliza tu producto eligiendo tu jugador favorito o agregando el nombre y número que quieras'}
				</Typography>
			</Box>

			<FormControl fullWidth sx={{ mb: 2 }}>
				<Stack spacing={2}>
					<RadioGroup
						name="option"
						row
						value={values.option}
						onChange={handleInputChange}
						sx={{ width: '100%' }}
					>
						<Box
							sx={{
								display: 'flex',
								width: '100%',
								border: '1px solid #ccc',
								borderRadius: '6px',
								overflow: 'hidden',
							}}
						>
							<FormControlLabel
								value={OPTIONS.PLAYER}
								control={<Radio />}
								label="Jugador"
								sx={{
									fontSize: '15px',
									flex: 1,
									m: 0,
									px: 2,
									py: 1,
									borderRight: '1px solid #ccc',
									justifyContent: 'center',
									'& .MuiRadio-root': {
										p: 0.5,
									},
									'&.MuiFormControlLabel-root': {
										backgroundColor:
											values.option === OPTIONS.PLAYER ? '#e6f0ff' : 'transparent',
									},
								}}
							/>

							<FormControlLabel
								value={OPTIONS.CUSTOM}
								control={<Radio />}
								label="Añade el tuyo"
								sx={{
									fontSize: '15px',
									flex: 1,
									m: 0,
									px: 2,
									py: 1,
									justifyContent: 'center',
									'& .MuiRadio-root': {
										p: 0.5,
									},
									'&.MuiFormControlLabel-root': {
										backgroundColor:
											values.option === OPTIONS.CUSTOM ? '#e6f0ff' : 'transparent',
									},
								}}
							/>
						</Box>
					</RadioGroup>
					{
						values.option === OPTIONS.PLAYER
							?
							<FormControl fullWidth variant="outlined">
								<InputLabel
									id="player-label"
									sx={{
										padding: '0px',
										color: 'inherit',
										lineHeight: 1,
										height: '20px',
										fontSize: 'var(--font-size-body)',
									}}
								>
									{'Seleccionar jugador'}
								</InputLabel>
								<DpOutlinedSelect
									labelId="player-label"
									name="player"
									value={values.player}
									label="Seleccionar jugador"
									sx={{
										'& .MuiSelect-select': { textAlign: 'center' },
									}}
									onChange={handleSelectChange}
								>
									<MenuItem value="a">{'01 - Nombre Jugador2'}</MenuItem>
									<MenuItem value="b">{'02 - Nombre Jugador1'}</MenuItem>
								</DpOutlinedSelect>
							</FormControl>
							:
							<Stack spacing={1} direction="row">
								<DpOutlinedInput
									label="00"
									value={values.customNumber}
									name="customNumber"
									sx={{width: '200px'}}
									type="text"
									inputProps={{maxLength: 2, inputMode: 'numeric', pattern: '[0-9]*'}}
									onInput={handleInput}
									onChange={handleInputChange}
								/>
								<DpOutlinedInput
									label="Nombre"
									value={values.customName}
									name="customName"
									sx={{flex: 1}}
									inputProps={{ maxLength: 10 }}
									onChange={handleInputChange}
									onInput={handleInput}
								/>
							</Stack>
					}
				</Stack>
			</FormControl>
		</React.Fragment>
	);
};
